import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../../../service/api";

export default function FgeModal({ show, onHide, row, onUpdated }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const [form, setForm] = useState({
        amount: "",
    });

    useEffect(() => {
        if (row) {
            setForm((prev) => ({
                ...prev,
                amount: row?.remaining_amount ?? "0.00",
            }));
        }
    }, [row]);

    const handleChange = (key, value) => {
        // keep amount as string to preserve user input
        if (key === "amount") {
            // ensure max based on remaining_amount
            const remaining = parseFloat(row?.remaining_amount || 0);
            let val = value === "" ? "" : value;
            const num = parseFloat(val || 0);
            if (!isNaN(num) && num > remaining) {
                val = String(remaining);
            }

            setForm((prev) => ({ ...prev, [key]: val }));
            return;
        }

        setForm((prev) => ({ ...prev, [key]: value }));
    };

    const resetState = () => {
        setForm({ amount: "" });
        setError("");
    };

    const handleClose = () => {
        resetState();
        onHide();
    };

    const handleSubmit = async () => {
        if (!row) return;

        const remaining = parseFloat(row?.remaining_amount || 0);
        const amount = parseFloat(form.amount || 0);
        if (isNaN(amount) || amount <= 0 || amount > remaining) return;

        try {
            setLoading(true);
            setError("");

            const payload = new FormData();
            if (row?.id) payload.append("id", row.id);
            payload.append("amount", amount);
            payload.append("type", "FGE");
            payload.append("reason", "fge");
            payload.append("status", "PENDING");

            await api.post(`tms/bank-transaction/close-fge/${row.id}`, payload);

            onUpdated?.();
            handleClose();
        } catch (error) {
            console.error(error);
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Unable to submit FGE. Please try again.";
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    const remainingAmount = parseFloat(row?.remaining_amount || 0).toFixed(2);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>FGE Action</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group className="mb-2">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control
                        type="number"
                        min={0}
                        max={row?.remaining_amount ?? undefined}
                        step="0.01"
                        value={form.amount ?? ""}
                        onChange={(e) => handleChange("amount", e.target.value)}
                    />
                    <div className="form-text">Remaining amount: {remainingAmount}</div>
                    {error && (
                        <div className="text-danger mt-2">{error}</div>
                    )}
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSubmit}
                    disabled={
                        loading ||
                        !form.amount ||
                        parseFloat(form.amount || 0) <= 0 ||
                        parseFloat(form.amount || 0) > parseFloat(row?.remaining_amount || 0)
                    }
                >
                    {loading ? "Processing..." : "Submit"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
